/*
 * SPDX-FileCopyrightText: 2026 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useIsLoggedIn } from '../../hooks/common/use-is-logged-in'
import { loadNoteTree, resetNoteTree, restoreNoteTreeSidebarOpen } from '../../redux/note-tree/methods'
import { useEffect } from 'react'

const REFRESH_INTERVAL_MS = 60 * 1000

/**
 * Loads the note tree for logged-in users and keeps it up to date while the page is visible,
 * by refreshing it periodically and whenever the window regains focus.
 */
export const useNoteTreeRefresh = (): void => {
  const isLoggedIn = useIsLoggedIn()

  useEffect(() => {
    restoreNoteTreeSidebarOpen()
  }, [])

  useEffect(() => {
    if (!isLoggedIn) {
      resetNoteTree()
      return
    }
    void loadNoteTree()
    const refreshIfVisible = () => {
      if (document.visibilityState === 'visible') {
        void loadNoteTree()
      }
    }
    const intervalId = window.setInterval(refreshIfVisible, REFRESH_INTERVAL_MS)
    window.addEventListener('focus', refreshIfVisible)
    return () => {
      window.clearInterval(intervalId)
      window.removeEventListener('focus', refreshIfVisible)
    }
  }, [isLoggedIn])
}
